import _ from "lodash";
export class BOMFormat {
    lineItems;
    static manufacturer = "";
    static columns = {};
    constructor(lineItems) {
        this.lineItems = lineItems;
    }
    get name() {
        return this.constructor.manufacturer;
    }
    get columns() {
        return this.constructor.columns;
    }
    get columnNames() {
        return Object.keys(this.columns);
    }
    getRowData() {
        return this.lineItems.map((lineItem, i) => Object.entries(this.columns).reduce((d, [label, getter]) => {
            if (typeof getter === "string") {
                d[label] = `${_.get(lineItem, getter) ?? ""}`;
            }
            else {
                d[label] = `${getter(lineItem, i + 1)}`;
            }
            return d;
        }, {}));
    }
}
//# sourceMappingURL=base.js.map